import React from 'react';

export default class impressum extends React.Component {

    render() {
        return <div className="container text-center" style={{marginTop: "80px"}}>
            <h2>Impressum</h2>
            <p>
                Joel Kernasenko<br/>
                Firmeninhaber: Joel Kernasenko<br/>
                Moosbrunnweg 8, 8042 Graz – Austria
                <br /><br />
                <b>Unternehmensgegenstand:</b> <br/>
                Fotografie/Berufsfotograf<br/>
                <a href="tel:%2B43%20%2F%20699%20171%20252%2043">+43 / 699 171 252 43</a><br />
                <a href="mailto:info@joelkernasenko.com">info@joelkernasenko.com</a><br />
                UID Nr: ATU 6763272<br />
                Mitglied der Wirtschaftskammer Steiermark,<br />
                LI Berufsfotografen: Fotografen<br /><br /><br />

                <b>Berufsrecht:</b><br />Gewerbeordnung:&nbsp;
                <a href="http://www.ris.bka.gv.at/" target="_blank" rel="noreferrer"
                    data-saferedirecturl="https://www.google.com/url?hl=de&amp;q=http://www.ris.bka.gv.at/&amp;source=gmail&amp;ust=1498557954341000&amp;usg=AFQjCNFkhg_1hk2daK7CFPnRLMEJI-A3uQ">http://www.ris.bka.gv.at/</a><br />
                Gewerbebehörde: Magistrat Stadt Graz<br />Berufsfotograf<br />Gewerbeberechtigung als
                Berufsfotograf<br /><br /><br />Grundlegende Richtung der Website: Diese Webseite von Joel
                Kernasenko<br />soll der &Ouml;ffentlichkeit Zugang zu Information &uuml;ber die Arbeiten
                und<br />T&auml;tigkeiten von Joel Kernasenko und seinem Unternehmen erm&ouml;glichen.<br /><br /><br />
                <b>Weitere Informationen auf der Website der Wirtschaftskammer &Ouml;sterreich:</b><br /><a
                    href="https://firmen.wko.at/Web/DetailsInfos.aspx?FirmaID=504b2f3a-e00e-4ef1-a609-b7b1b8cc853d&amp;StandortID=0&amp;Suchbegriff=joel+kernasenko&amp;Page=1"
                    target="_blank" rel="noreferrer"
                    data-saferedirecturl="https://firmen.wko.at/Web/DetailsInfos.aspx?FirmaID=504b2f3a-e00e-4ef1-a609-b7b1b8cc853d&StandortID=0&Suchbegriff=joel+kernasenko&Page=1">Zur WKO Webseite
                    </a><br /><br /></p>
        </div>
    }

}


// WEBPACK FOOTER //
// ./src/scripts/pages/impressum.jsx